import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, map } from 'rxjs';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private portal: string) {}

  getTranslation(lang: string): Observable<any> {
    const basePath = `assets/i18n/${lang}`;
    const files = [`common`, this.portal]; // shared + portal-specific

    const requests = files.map(file =>
      this.http.get(`${basePath}/${file}.json`)
    );

    return forkJoin(requests).pipe(
      map(translations => Object.assign({}, ...translations))
    );
  }
}
